import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import {
  LEGACY_PROJECT_ID_QUERY,
  PROJECT_INDEX_QUERY,
  projectsRoutesConfig,
} from 'domains/projects/routes';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useJWTs } from 'domains/jwtToken/hooks/useJWTs';
import { useQueryParams } from 'modules/common/hooks/useQueryParams';

/**
 * Replaces the legacy projectId query param (the project API key) with the
 * projectIndex param, so old links keep working while the API key is removed
 * from the url and browser history.
 */
export const useLegacyProjectIdRedirect = () => {
  const navigate = useNavigate();
  const query = useQueryParams();

  const { legacyProjectId } = projectsRoutesConfig.project.useParams();

  const { group } = useAccount();

  const { jwts } = useJWTs({ group, skipFetching: true });

  useEffect(() => {
    if (!legacyProjectId) {
      return;
    }

    const project = jwts.find(
      jwt =>
        jwt.userEndpointToken.toLowerCase() === legacyProjectId.toLowerCase(),
    );

    if (!project) {
      return;
    }

    query.delete(LEGACY_PROJECT_ID_QUERY);
    query.set(PROJECT_INDEX_QUERY, project.index.toString());

    navigate({ search: query.toString() }, { replace: true });
  }, [jwts, legacyProjectId, navigate, query]);
};
